function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from "@apollo/client";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import * as Localization from "expo-localization";
import { Fragment, useEffect, useState } from "react";
import { SystemBars } from "react-native-edge-to-edge";
import { ActivityIndicator } from "@oui/app-core/src/components/ActivityIndicator";
import { ScrollView } from "@oui/app-core/src/components/ScrollView";
import { SessionCard } from "@oui/app-core/src/components/SessionCard";
import { TabHeader } from "@oui/app-core/src/components/TabHeader";
import { View } from "@oui/app-core/src/components/View";
import { graphql } from "@oui/lib/src/graphql/tada";
import { ContentType } from "@oui/lib/src/types";
import { useNavigateToStaticSessionHook } from "../hooks/useNavigateToStaticSessionHook";
export var SetLocaleAndTimezoneMutation = graphql('\n  mutation SetLocaleAndTimezone($locale: Any!, $timezone: Any!) {\n    locale: kvRespond(context: "user", key: "locale", data: $locale) {\n      context\n      key\n    }\n    timezone: kvRespond(context: "user", key: "timezone", data: $timezone) {\n      context\n      key\n    }\n  }\n');
var SESSIONS = [
    {
        ordinal: 1,
        title: "Session 1",
        subtitle: null,
        description: '',
        slug: ContentType.STATIC_01
    },
    {
        ordinal: 2,
        title: "Session 2",
        subtitle: null,
        description: '',
        slug: ContentType.STATIC_02
    },
    {
        ordinal: 3,
        title: "Session 3",
        subtitle: null,
        description: '',
        slug: ContentType.STATIC_03
    },
    {
        ordinal: 4,
        title: "Session 4",
        subtitle: null,
        description: '',
        slug: ContentType.STATIC_04
    },
    {
        ordinal: 5,
        title: "Session 5",
        subtitle: null,
        description: '',
        slug: ContentType.STATIC_05
    },
    {
        ordinal: 6,
        title: "Session 6",
        subtitle: null,
        description: '',
        slug: ContentType.STATIC_06
    },
    {
        ordinal: 7,
        title: "Session 7",
        subtitle: null,
        description: '',
        slug: ContentType.STATIC_07
    },
    {
        ordinal: 8,
        title: "Session 8",
        subtitle: null,
        description: '',
        slug: ContentType.STATIC_08
    },
    {
        ordinal: 9,
        title: "Session 9",
        subtitle: null,
        description: '',
        slug: ContentType.STATIC_09
    },
    {
        ordinal: 10,
        title: "Session 10",
        subtitle: null,
        description: '',
        slug: ContentType.STATIC_10
    },
    {
        ordinal: 11,
        title: "Session 11",
        subtitle: null,
        description: '',
        slug: ContentType.STATIC_11
    },
    {
        ordinal: 12,
        title: "Session 12",
        subtitle: null,
        description: '',
        slug: ContentType.STATIC_12
    }
];
export function LearnStatic(param) {
    var _param_sessions = param.sessions, sessions = _param_sessions === void 0 ? SESSIONS : _param_sessions;
    var navigation = useNavigation();
    var isFocused = useIsFocused();
    var _useState = _sliced_to_array(useState(true), 2), loading = _useState[0], setLoading = _useState[1];
    useEffect(function() {
        var timeout;
        if (isFocused) {
            timeout = setTimeout(function() {
                setLoading(false);
            }, 500);
        } else {
            setLoading(true);
        }
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        isFocused
    ]);
    var _useMutation = _sliced_to_array(useMutation(SetLocaleAndTimezoneMutation), 1), setLocaleAndTimezone = _useMutation[0];
    useEffect(function() {
        void setLocaleAndTimezone({
            variables: {
                locale: Localization.getLocales()[0].languageTag,
                timezone: Localization.getCalendars()[0].timeZone
            }
        });
    }, [
        setLocaleAndTimezone
    ]);
    var navigateToStaticSession = useNavigateToStaticSessionHook({
        navigation: navigation
    }).navigateToStaticSession;
    return /*#__PURE__*/ _jsxs(View, {
        testID: "LearnStatic",
        style: {
            flex: 1
        },
        children: [
            isFocused ? /*#__PURE__*/ _jsx(SystemBars, {
                style: "dark"
            }) : null,
            /*#__PURE__*/ _jsxs(ScrollView, {
                testID: "LearnStatic_scrollView",
                style: {
                    flex: 1
                },
                contentContainerStyle: {
                    paddingHorizontal: 20,
                    paddingBottom: 20
                },
                children: [
                    /*#__PURE__*/ _jsx(TabHeader, {
                        heading: "Learn"
                    }),
                    !loading ? /*#__PURE__*/ _jsx(View, {
                        style: {
                            marginTop: 20,
                            gap: 10
                        },
                        children: sessions.map(function(item, i) {
                            var isUnlocked = !(item === null || item === void 0 ? void 0 : item.unlockedAt) || (item === null || item === void 0 ? void 0 : item.unlockedAt) < new Date().toISOString();
                            var _item_subtitle;
                            return /*#__PURE__*/ _jsx(Fragment, {
                                children: /*#__PURE__*/ _jsx(SessionCard, {
                                    hideHeader: true,
                                    static: true,
                                    testID: "SessionCard_".concat(item.slug),
                                    state: isUnlocked ? 'unlocked' : 'locked',
                                    unlockedAt: isUnlocked ? null : item.unlockedAt,
                                    session: {
                                        num: item.ordinal,
                                        title: item.title,
                                        subtitle: (_item_subtitle = item.subtitle) !== null && _item_subtitle !== void 0 ? _item_subtitle : undefined,
                                        details: [],
                                        illustrationUrl: undefined
                                    },
                                    onPressTop: function() {
                                        navigateToStaticSession({
                                            contentType: item.slug,
                                            name: item.title
                                        }, 'sessions');
                                    }
                                })
                            }, i);
                        })
                    }) : /*#__PURE__*/ _jsx(ActivityIndicator, {})
                ]
            })
        ]
    });
}
